<div class="row">
    <div class="col-md-4">
        <div class="form-group surveyQuestion">
            <label class="questionText">1. Select a country</label>
            <select
                [(ngModel)]="countryId"
                (change)=getRegionByCountry()
                class="form-control"
                name="countryId"
            >
                <option
                    [value]="undefined"
                    disabled
                ></option>
                <option
                    *ngFor="let country of countries"
                    [value]="country.id"
                >{{country.name}}</option>
            </select>
        </div>
    </div>
    <div
        class="col-md-4"
        *ngIf="showRegion"
    >
        <div class="form-group surveyQuestion">
            <label class="questionText">2. Select a region</label>
            <select
                [(ngModel)]="regionId"
                (change)=getTestCentreSittings()
                class="form-control"
                name="region"
            >
                <option
                    *ngFor="let region of regions"
                    [value]="region.id"
                >{{region.name}}</option>
            </select>
        </div>
    </div>
</div>
<div *ngIf="showTestCentre">
    <div class="row">
        <div class="col-md-4">
            <div class="form-group surveyQuestion">
                <label class="questionText">2. Select a test centre</label>
                <select
                    [(ngModel)]="testCentreId"
                    (change)=filterSittingsByCentre()
                    class="form-control"
                    name="centre"
                >
                    <option
                        disabled
                        value="null"
                    ></option>
                    <option
                        *ngFor="let testCentre of testCentres"
                        [value]="testCentre.id"
                    >{{testCentre.name}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="form-group surveyQuestion">
                <label class="questionText"><span>3. </span>Select a test sitting</label>
            </div>
        </div>
    </div>
</div>
<div *ngIf="cities?.length>0">
    <div class="row">
        <div class="col-md-4">
            <div class="form-group surveyQuestion">
                <label class="questionText"><span *ngIf="!showRegion">2. </span><span *ngIf="showRegion">3. </span>Select a city</label>
                <select
                    [(ngModel)]="city"
                    (change)=filterSittingsByCity()
                    class="form-control"
                    name="city"
                >
                    <option
                        disabled
                        value="null"
                    ></option>
                    <option
                        *ngFor="let city of cities"
                        [value]="city"
                    >{{city}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="form-group surveyQuestion">
                <label class="questionText"><span *ngIf="!showRegion">3. </span><span *ngIf="showRegion">4. </span>Select a test sitting</label>
            </div>
        </div>
    </div>
</div>
<app-modal
    #warningModal
    title="Nigerian Test Location"
    body="For the tests in Nigeria, we currently accept payments in Canadian dollars via PayPal. However, we are working on a solution to accept payments in Naira in the near future. As soon as further information is available, we will provide an update through our newsletter and on social media."
>
</app-modal>
